module.exports = __webpack_public_path__ + "static/media/watchlist.e14d4850.svg";